import { AnalyticUiEvent } from '@/scripts/libs/analytic/types';
import { EmitPayload } from '../presenters/layout/VideoPlayerOverlayBase';
import analytic from '@/scripts/libs/analytic';
import {
  accumulateSectionUi,
  AccumulateUiSectionFormat,
  finalizeSectionUi,
} from '@/scripts/libs/analytic/section-ui-accumulator';

export enum UiEventType {
  Shown,
  Dismiss,
  Action,
};

const getShownTrackerEvent = (overlaySectionPath: string | null, parentSectionPath: string | null): AnalyticUiEvent => ({
  action: 'shown',
  section: parentSectionPath,
  itemClass: overlaySectionPath,
});
const getActionTrackerEvent = (overlaySectionPath: string | null): AnalyticUiEvent => ({
  action: 'click-button',
  label: 'action',
  section: overlaySectionPath,
  itemClass: 'ui/video/video-player-overlays/components/overlay-button',
});
const getDismissTrackerEvent = (overlaySectionPath: string | null): AnalyticUiEvent => ({
  action: 'click-button',
  label: 'dismiss',
  section: overlaySectionPath,
  itemClass: 'ui/video/video-player-overlays/components/footer-button',
});

const getTrackerEvent = (type: UiEventType, payload: EmitPayload, trackable?: HTMLElement | null): AnalyticUiEvent => {
  const uiSections = trackable
    ? accumulateSectionUi(trackable, {
      format: AccumulateUiSectionFormat.Array,
      shouldTrackSelf: true,
    })
    : []
  ;

  const hasUiSections = uiSections.length > 0;

  const parentSectionPath = hasUiSections ? finalizeSectionUi(uiSections.slice(0, -1)) : null;
  const selfSectionPath = hasUiSections ? finalizeSectionUi(uiSections) : null;

  switch (type) {
    case UiEventType.Shown:
      return getShownTrackerEvent(selfSectionPath, parentSectionPath);
    case UiEventType.Action:
      return getActionTrackerEvent(selfSectionPath);
    case UiEventType.Dismiss:
      return getDismissTrackerEvent(selfSectionPath);
    default:
      throw new Error('FATAL: Invalid type provided');
  }
};

export const trackUiEvent = (type: UiEventType, payload: EmitPayload, trackable?: HTMLElement | null): void => {
  const eventData: AnalyticUiEvent = {
    ...getTrackerEvent(type, payload, trackable),
    ...payload.tracker,
  };

  analytic.trackUiEvent(eventData);
};
